// @mui
import { alpha, Box, Stack } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

// ----------------------------------------------------------------------

export default function AuthStatisticsSkeleton() {
  return (
    <Stack spacing={4.75} sx={{ py: 2 }}>
      {[...Array(3)].map((__, index) => (
        <Stack key={index} direction="row" alignItems="center" justifyContent="space-between">
          <Skeleton sx={{ width: { xs: 100, sm: 150 }, height: 10, borderRadius: 1 }} />

          <Skeleton sx={{ width: { xs: 50, sm: 100 }, height: 10, borderRadius: 1 }} />
        </Stack>
      ))}
    </Stack>
  );
}
